/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 会員登録するリクエストを表します。
 * @export
 * @interface SignupRequestModel
 */
export interface SignupRequestModel {
    /**
     * 会員登録する唯一のメールアドレス
     * @type {string}
     * @memberof SignupRequestModel
     */
    mailAddress: string;
    /**
     * 会員登録するパスワードのパスワード
     * @type {string}
     * @memberof SignupRequestModel
     */
    password?: string;
    /**
     * コミチID
     * @type {string}
     * @memberof SignupRequestModel
     */
    comiciId: string;
    /**
     * 性別
     * @type {number}
     * @memberof SignupRequestModel
     */
    genderType?: number;
    /**
     * 生まれた年
     * @type {number}
     * @memberof SignupRequestModel
     */
    yearAge?: number;
    /**
     * ユーザーのタイプ
     * @type {number}
     * @memberof SignupRequestModel
     */
    userType?: number;
    /**
     * 利用規約とプライバシーポリシーに同意するかどうかのフラグ
     * @type {boolean}
     * @memberof SignupRequestModel
     */
    isAgreementChecked: boolean;
    /**
     * ソーシャルで会員登録用の暗号化されたソーシャルタイプ
     * @type {string}
     * @memberof SignupRequestModel
     */
    encodeType?: string;
    /**
     * ソーシャルで会員登録用の暗号化されたソーシャルID
     * @type {string}
     * @memberof SignupRequestModel
     */
    encodeSocialId?: string;
}

/**
 * Check if a given object implements the SignupRequestModel interface.
 */
export function instanceOfSignupRequestModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mailAddress" in value;
    isInstance = isInstance && "comiciId" in value;
    isInstance = isInstance && "isAgreementChecked" in value;

    return isInstance;
}

export function SignupRequestModelFromJSON(json: any): SignupRequestModel {
    return SignupRequestModelFromJSONTyped(json, false);
}

export function SignupRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mailAddress': json['mailAddress'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'comiciId': json['comiciId'],
        'genderType': !exists(json, 'genderType') ? undefined : json['genderType'],
        'yearAge': !exists(json, 'yearAge') ? undefined : json['yearAge'],
        'userType': !exists(json, 'userType') ? undefined : json['userType'],
        'isAgreementChecked': json['isAgreementChecked'],
        'encodeType': !exists(json, 'encodeType') ? undefined : json['encodeType'],
        'encodeSocialId': !exists(json, 'encodeSocialId') ? undefined : json['encodeSocialId'],
    };
}

export function SignupRequestModelToJSON(value?: SignupRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mailAddress': value.mailAddress,
        'password': value.password,
        'comiciId': value.comiciId,
        'genderType': value.genderType,
        'yearAge': value.yearAge,
        'userType': value.userType,
        'isAgreementChecked': value.isAgreementChecked,
        'encodeType': value.encodeType,
        'encodeSocialId': value.encodeSocialId,
    };
}

